function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_x0020_1"
}, React.createElement("metadata", {
  id: "CorelCorpID_0Corel-Layer"
}), React.createElement("path", {
  fill: "currentColor",
  d: "M130 224c5,0 40,0 40,0 12,4 14,14 14,14 0,2 1,5 1,9 0,6 -1,8 -2,10 -4,11 -13,14 -13,14l-40 0 0 -47zm100 8l0 -1c-1,-3 -11,-33 -45,-37l-1 0 -101 0 0 171 47 0c0,0 0,-57 0,-62 6,0 53,-1 53,-1l0 0c2,0 36,-4 46,-37l1 -1c0,0 2,-7 2,-17 0,-8 -2,-15 -2,-15z"
}), React.createElement("polygon", {
  fill: "currentColor",
  points: "0,194 0,365 48,365 48,194 "
}), React.createElement("path", {
  fill: "#ED3237",
  d: "M77 98c0,11 9,20 21,20 11,0 20,-9 20,-20 0,-12 -9,-21 -20,-21 -12,0 -21,9 -21,21z"
}), React.createElement("path", {
  fill: "#ED3237",
  d: "M171 54c0,18 14,32 32,32 17,0 32,-14 32,-32 0,-17 -15,-32 -32,-32 -18,0 -32,15 -32,32z"
}), React.createElement("path", {
  fill: "#ED3237",
  d: "M296 41c0,22 18,41 41,41 22,0 41,-19 41,-41 0,-23 -19,-41 -41,-41 -23,0 -41,18 -41,41z"
}), React.createElement("path", {
  fill: "#ED3237",
  d: "M519 194c0,27 23,50 51,50 28,0 50,-23 50,-50 0,-28 -22,-51 -50,-51 -28,0 -51,23 -51,51z"
}), React.createElement("path", {
  fill: "#ED3237",
  d: "M433 80c0,26 21,47 47,47 26,0 46,-21 46,-47 0,-26 -20,-47 -46,-47 -26,0 -47,21 -47,47z"
}), React.createElement("path", {
  fill: "#ED3237",
  d: "M440 226l0 -33 -123 0 0 172 48 0 -5 -5 5 5c0,0 0,-61 0,-67 6,0 70,0 70,0l0 -32c0,0 -65,0 -70,0l0 -40c5,0 75,0 75,0z"
}), React.createElement("path", {
  fill: "#ED3237",
  d: "M651 246c11,-18 14,-41 15,-50l0 -4 -35 0 -1 3c0,7 -3,30 -15,42 -14,14 -29,19 -45,24 -17,-5 -32,-10 -46,-24 -12,-12 -14,-35 -15,-42l0 -3 -36 0 1 4c1,9 4,32 14,50 13,22 40,37 40,37 -19,6 -31,16 -41,33 -9,14 -11,36 -12,45l0 4 56 0 0 -3c0,-10 1,-19 4,-32 7,-24 34,-28 35,-28 1,0 27,4 34,28 4,13 5,22 5,32l0 3 56 0 0 -4c-1,-9 -4,-31 -12,-45 -10,-17 -23,-27 -42,-33 1,0 27,-15 40,-37z"
}), React.createElement("path", {
  fill: "#ED3237",
  d: "M14 161c0,7 6,13 13,13 7,0 13,-6 13,-13 0,-7 -6,-13 -13,-13 -7,0 -13,6 -13,13z"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlSpace: "preserve",
    version: 1.1,
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 666 365",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/IPFX.5fd9e6e1.svg";
export { SvgComponent as ReactComponent };